// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as AllocationDashboardRepoManager from "./AllocationDashboardRepoManager.bs.js";

function fetchAllocationCampaigns(param, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchAllocationCampaigns, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function getUserAccessLevel(param, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.getUserAccessLevel, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function createMandatoryCampaign(payload, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createMandatoryCampaign, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateMandatoryCampaign(payload, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.updateMandatoryCampaign, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function createZonalOrClusterCampaign(payload, onSuccess, onFailure) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.createZonalOrClusterCampaign, payload);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchZoneClusterCampaigns(param, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchZoneClusterCampaigns, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateZoneClusterCampaigns(param, onSuccess, onFailure, country) {
  var RepoInstance = AllocationDashboardRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateZoneClusterCampaigns, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchAllocationCampaigns ,
  getUserAccessLevel ,
  createMandatoryCampaign ,
  updateMandatoryCampaign ,
  createZonalOrClusterCampaign ,
  fetchZoneClusterCampaigns ,
  updateZoneClusterCampaigns ,
  
}
/* AllocationDashboardRepoManager Not a pure module */
